import React from "react"
import ImageGallery from "react-image-gallery"
import "react-image-gallery/styles/css/image-gallery.css"

const photos = [
  {
    original: "/images/concept/1.jpg",
    thumbnail: "/images/concept/1-thumbnail.jpg",
    thumbnailAlt: "美容室の外観",
    originalTitle: "美容室の外観",
  },
  {
    original: "/images/concept/2.jpg",
    thumbnail: "/images/concept/2-thumbnail.jpg",
    thumbnailAlt: "美容室のカット台",
    originalTitle: "美容室のカット台",
  },
  {
    original: "/images/concept/3.jpg",
    thumbnail: "/images/concept/3-thumbnail.jpg",
    thumbnailAlt: "美容室の内装",
    originalTitle: "美容室の内装",
  },
  {
    original: "/images/concept/4.jpg",
    thumbnail: "/images/concept/4-thumbnail.jpg",
    thumbnailAlt: "美容室のシャンブー台",
    originalTitle: "美容室のシャンブー台",
  },
]

export const Gallery = () => {
  return (
    <ImageGallery
      autoPlay={true}
      slideInterval={4500}
      showNav={false}
      items={photos}
      showPlayButton={false}
      showFullscreenButton={false}
    />
  )
}

export default Gallery
